import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { PatientConsumerRenderProps, PatientContext } from 'components/patient/PatientContext';
import { TreatmentsConsumerRenderProps, TreatmentsContext } from 'components/treatments/TreatmentsContext';
import TreatmentsInfo from 'components/treatments/TreatmentsInfo';
import { MessageSourceProps, withMessages } from "react-message-source";
import TreatmentsToolbar from 'components/treatments/TreatmentsToolbar';
import { ConsultationsConsumerRenderProps, ConsultationsContext } from 'components/consultations/ConsultationsContext';
import HomeLeftHeaderTitle from 'components/layout/HomeLeftHeaderTitle';
import HomeLeftHeader from 'components/layout/HomeLeftHeader';

const StyledTreatment = styled(Segment)`
  height: 386px;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

const Treatments = (props: MessageSourceProps) => {

  const {currentPatient}: PatientConsumerRenderProps = useContext(PatientContext);
  const {
    currentTreatments,
    changeTreatments,
    changeSelectedTreatment,
    selectedTreatment,
    addTreatment,
    editTreatment,
    toggleUpsertModal,
    treatmentFormOpen,
    deleteTreatment,
    treatment,
    getTreatment
  }: TreatmentsConsumerRenderProps = useContext(TreatmentsContext);

  const {currentConsultations}: ConsultationsConsumerRenderProps = useContext(ConsultationsContext);

  return (
      <StyledTreatment>
        <HomeLeftHeader>
          <HomeLeftHeaderTitle>{props.getMessage('treatments')}</HomeLeftHeaderTitle>
          <TreatmentsToolbar currentPatient={currentPatient}
                             addTreatment={addTreatment}
                             editTreatment={editTreatment}
                             deleteTreatment={deleteTreatment}
                             getTreatment={getTreatment}
                             selectedTreatment={selectedTreatment}
                             currentConsultations={currentConsultations}
                             toggleUpsertModal={toggleUpsertModal}
                             changeTreatments={changeTreatments}
          />
        </HomeLeftHeader>
        <TreatmentsInfo
            currentPatient={currentPatient}
            currentTreatments={currentTreatments}
            currentConsultations={currentConsultations}
            toggleUpsertModal={toggleUpsertModal}
            getTreatment={getTreatment}
            treatment={treatment}
            treatmentFormOpen={treatmentFormOpen}
            changeTreatments={changeTreatments}
            changeSelectedTreatment={changeSelectedTreatment}
            selectedTreatment={selectedTreatment}
            addTreatment={addTreatment}
            editTreatment={editTreatment}
        />
      </StyledTreatment>
  )
};

export default withMessages(Treatments);
